import {OFFLINE_STORES,getOfflineStorageDriver} from './offlineStorageAdapter.js';
import {isNativePlatform} from '../mobile/capacitorPlatform.js';

const DB_NAME='coordinacion_visitas_offline',STORE_NAME='visita_offline_entries';
let pending=null;

async function openLegacy(idb){
    if(!idb)return null;
    return new Promise((resolve,reject)=>{
        const request=idb.open(DB_NAME);
        request.onupgradeneeded=()=>{request.transaction.abort();};
        request.onsuccess=()=>resolve(request.result);
        request.onerror=()=>request.error?.name==='AbortError'?resolve(null):reject(request.error);
    });
}
export async function readLegacyContextSources({idb=typeof window==='undefined'?null:window.indexedDB,local=typeof window==='undefined'?null:window.localStorage,limit=201}={}){
    const result=[],db=await openLegacy(idb);
    if(db){try{
        if(db.objectStoreNames.contains(STORE_NAME))await new Promise((resolve,reject)=>{
            const tx=db.transaction(STORE_NAME,'readonly'),range=typeof IDBKeyRange==='undefined'?undefined:IDBKeyRange.bound('context:','context:\uffff'),request=tx.objectStore(STORE_NAME).openCursor(range);
            request.onsuccess=()=>{const cursor=request.result;if(!cursor)return;const entry=cursor.value;if(/^context:\d+$/.test(String(entry?.key)))result.push({source:'idb',key:entry.key,entry});if(result.length<limit)cursor.continue();};
            tx.oncomplete=resolve;tx.onerror=()=>reject(tx.error);tx.onabort=()=>reject(tx.error);
        });
    }finally{db.close();}}
    if(local)for(let n=0;n<local.length&&result.length<limit;n++){
        const key=local.key(n);if(!/^cached_context_\d+$/.test(key||''))continue;
        const raw=local.getItem(key);if(!raw)continue;
        try{result.push({source:'local',key,entry:JSON.parse(raw),raw});}catch{result.push({source:'local',key,entry:{unparsed:raw},raw});}
    }
    return result;
}
// Estas copias no tienen identidad verificable. Se conservan completas como recuperación,
// sin convertirlas en un formulario autorizado ni leerlas durante el trabajo normal.
export function migrateLegacyVisitaContexts({driver=getOfflineStorageDriver(),native=isNativePlatform(),readSources=readLegacyContextSources}={}){
    if(!native)return Promise.resolve({migrated:0});
    if(pending)return pending;
    pending=(async()=>{
        await driver.init();if(driver.effectiveEngine!=='sqlite')throw Error('La migración de formularios requiere SQLite.');
        let migrated=0;
        const sources=await readSources();
        for(const record of sources.slice(0,200)){
            const serialized=JSON.stringify(record),bytes=new TextEncoder().encode(serialized);
            const sha256=[...new Uint8Array(await crypto.subtle.digest('SHA-256',bytes))].map(value=>value.toString(16).padStart(2,'0')).join('');
            const id=`legacy-context:${record.source}:${record.key}:${sha256}`,visitaId=Number(record.entry?.visitaId||String(record.key).match(/\d+$/)?.[0])||0;
            const row={id,kind:'legacy_recovery',userId:0,empresaId:0,visitaId,scope:'legacy-unverified',version:sha256,templateVersion:'unverified',legacy:record.entry,sourceRecord:record,sha256,size:bytes.length,savedAt:Date.now()};
            const previous=await driver.get(OFFLINE_STORES.CONTEXTS,id);
            if(!previous)await driver.put(OFFLINE_STORES.CONTEXTS,row);
            const saved=await driver.get(OFFLINE_STORES.CONTEXTS,id);
            if(saved?.sha256!==sha256||saved.size!==bytes.length||JSON.stringify(saved.sourceRecord)!==serialized
                ||JSON.stringify(saved.legacy)!==JSON.stringify(record.entry))throw Error('No se confirmó el respaldo del formulario anterior.');
            if(!previous)migrated++;
        }
        if(sources.length>200)throw Error('Hay más formularios anteriores que requieren recuperación.');
        return {migrated,verified:sources.length,preserved:true};
    })().finally(()=>{pending=null;});
    return pending;
}
